import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const iconPaths = {
  calendar: "M46.9,0c0.8,0,1.6,0.3,2.2,0.9C49.7,1.5,50,2.3,50,3.1v43.8c0,1.7-1.4,3.1-3.1,3.1H3.1c-0.8,0-1.6-0.3-2.2-0.9C0.3,48.5,0,47.7,0,46.9V3.1c0-0.8,0.3-1.6,0.9-2.2C1.5,0.3,2.3,0,3.1,0h4.2v6.2c0,0.8,0.3,1.6,0.9,2.2c1.2,1.2,3.2,1.2,4.4,0c0,0,0,0,0,0c0.6-0.6,0.9-1.4,0.9-2.2V0h22.9v6.2c0,0.8,0.3,1.6,0.9,2.2c1.2,1.2,3.2,1.2,4.4,0c0,0,0,0,0,0c0.6-0.6,0.9-1.4,0.9-2.2V0H46.9z M15.6,28.1v-8.3H7.3v8.3L15.6,28.1z M15.6,42.7v-8.3H7.3v8.3H15.6z M29.2,28.1v-8.3h-8.4v8.3L29.2,28.1z M29.2,42.7v-8.3h-8.4v8.3H29.2z M42.7,28.1v-8.3h-8.3v8.3L42.7,28.1z M42.7,42.7v-8.3h-8.3v8.3H42.7z",
  calendarcheck: "M45.9,0c0.8,0,1.6,0.3,2.2,0.9C48.7,1.5,49,2.2,49,3.1v42.9c0,1.7-1.4,3.1-3.1,3.1H3.1c-0.8,0-1.6-0.3-2.2-0.9C0.3,47.5,0,46.8,0,45.9V3.1c0-0.8,0.3-1.6,0.9-2.2C1.5,0.3,2.2,0,3.1,0h4.1v6.1c0,0.8,0.3,1.6,0.9,2.2c1.2,1.2,3.1,1.2,4.3,0c0,0,0,0,0,0c0.6-0.6,0.9-1.4,0.9-2.2V0h22.4v6.1c0,0.8,0.3,1.6,0.9,2.2c1.2,1.2,3.1,1.2,4.3,0c0,0,0,0,0,0c0.6-0.6,0.9-1.4,0.9-2.2V0H45.9z M21.4,41.1l16.4-16.4l-4.3-4.3L21.4,32.4l-6-6l-4.3,4.3L21.4,41.1z",
  walking: "M0.0947755355,8.10022355 L0.519855297,7.34016393 C1.17679675,6.16207154 2.16220892,5.19299553 3.36016098,4.54694486 C4.03642424,4.18591654 4.34557315,4.09090909 4.65472207,4.09090909 L6.08453581,4.18591654 C6.50961558,4.20491803 6.81876449,4.39493294 8.05536016,5.95305514 C8.4224745,6.40909091 8.84755427,6.80812221 9.34992126,7.13114754 L10.2387244,7.70119225 C10.6444823,7.96721311 10.7604132,8.48025335 10.4899079,8.87928465 C10.2194026,9.27831595 9.69771379,9.39232489 9.29195583,9.12630402 L8.4031527,8.55625931 C7.78485486,8.15722802 7.22452245,7.66318927 6.76079907,7.09314456 L6.06521401,10.3423994 L7.41774052,11.6345007 C7.95875113,12.147541 8.34518727,12.8125931 8.51908354,13.5536513 L9.31127764,16.7269001 C9.44653029,17.2779434 9.09873776,17.8289866 8.53840535,17.961997 C8.46111812,17.9809985 8.36450908,18 8.28722185,18 C7.82349848,18 7.39841871,17.6959762 7.28248787,17.2209389 L6.49029377,14.04769 C6.39368473,13.6866617 6.21978847,13.3636364 5.94928316,13.116617 L4.59675665,11.8245156 L4.461504,12.7175857 C4.38421677,13.1736215 4.24896412,13.6106557 4.05574604,14.0286885 L2.43271422,17.4109538 C2.25881796,17.7719821 1.87238181,18 1.48594566,18 C1.33137121,18 1.19611855,17.961997 1.0415441,17.9049925 C0.519855297,17.6579732 0.307315416,17.0499255 0.539177105,16.5368852 L2.16220892,13.15462 C2.27813977,12.9266021 2.355427,12.6605812 2.39407061,12.4135618 L2.85779399,9.3733234 L3.18626471,6.75111773 C2.74186314,7.15014903 2.355427,7.6061848 2.04627808,8.13822653 L1.62119832,8.89828614 C1.46662386,9.18330849 1.15747494,9.33532042 0.86764783,9.33532042 C0.732395178,9.33532042 0.577820719,9.29731744 0.461889875,9.24031297 C0.0368101135,9.03129657 -0.117764345,8.51825633 0.0947755355,8.10022355 Z",
};

const CardWrapper = styled.div`
  min-height: auto;
  border-radius: 5px;
  border: solid;
  border-color: ${(props) => (props.featured ? "#3897A8" : "#cfd8dc")};
  border-width: ${(props) => (props.featured ? "2px" : "1px")};

  background-color: #ffffff;

  // ipad (portrait) and lower
  @media (min-width: 768px) {
    width: auto;
    min-height: unset;
  }

  // TODO: from 769 - 1280: 2 cards 1st row, one card on 2nd row

  // larger than ipad (portrait)
  @media all and (min-width: 769px) and (max-width: 1024px){
    width: 500px;
    margin: auto;
    min-height: unset;
  }
`;
CardWrapper.displayName = 'CardWrapper';

const ContentWrapper = styled.div`
  padding: 2.5rem 1.25rem 1.25rem;

  h2 {
    padding: 0;
    text-align: center;
  }

  svg {
    margin-left: 5px;
  }

  .quick-text {
    text-align: center;
    padding: 1.25rem 0 0 0;
  }

  & hr {
    margin: 1.25rem 0 0 0;
  }

  .text-button-style {
    font-weight: 600;
    color: #2680ad;
    text-decoration: underline;
    padding: 1.25rem 0 0 0;
  }

  .text-button-style:hover {
    color: #3e6d85;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 24px;
      line-height: 1.33;
    }
  }
`;
ContentWrapper.displayName = 'ContentWrapper';

const BannerWrapper = styled.div`
  background-color: ${(props) => (props.featured ? "#3897A8" : "inherit")};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  /* these prevent the whitespace gap between the banner bg color and the border upon browser zoom */
  margin-top: ${(props) => (props.featured ? "-1px" : "0")};
  margin-left: ${(props) => (props.featured ? "-1px" : "0")};
  margin-right: ${(props) => (props.featured ? "-1px" : "0")};
`;
BannerWrapper.displayName = 'BannerWrapper';

const FeatureWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  line-height: 28px;
  padding-top: 1.25rem;
`;
FeatureWrapper.displayName = 'FeatureWrapper';

const Feature = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  color: #42484D;
`;
Feature.displayName = 'Feature';

// *** TODO: REPLACE BELOW WITH NEW BUTTON COMPONENT ***
const ButtonContainer = styled.div`
  padding: 1.25rem 0 0 0;
  color: transparent;
  text-decoration: none;
  text-align: center;
  border-bottom: 0;
`;
ButtonContainer.displayName = 'ButtonContainer';

const Button = styled.button`
  height: 60px;
  color: #fff;
  font-weight: 600;
  background-color: #3897A8;
  border-style: none;
  border-radius: 5px;
  margin: auto;
  width: 100%;

  &:hover {
    background-color: #2b7582;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
Button.displayName = 'Button';
// *** TODO: REPLACE ABOVE HERE WITH NEW BUTTON COMPONENT ***

const DropDownButton = styled.button`
  color: unset !important;
  background-color: unset !important;
  padding: 1.25rem 0 0 0;
  cursor: pointer;
  outline: inherit;
`;
DropDownButton.displayName = 'DropDownButton';

const DropDownButtonContainer = styled.div`
  .dolla-dolla-bills {
    float: right;
    line-height: 1.75;
    text-align: right;
    color: #61686e;
    padding: 1.25rem 0 0 0;
  }
`;
DropDownButtonContainer.displayName = 'DropDownButtonContainer';

const DropDownContent = styled.div`
  padding: 1.25rem 0 0 0;
  overflow: hidden;

  @keyframes fadeIn {
    0% {
      max-height: 0;
    }
    100% {
      max-height: 500px;
    }
  }

  @keyframes fadeOut {
    0% {
      max-height: 500px;
    }
    100% {
      max-height: 0;
    }
  }

  ul {
    list-style: outside;
    padding-left: 1.25rem;
    padding-bottom: 1.25rem;
    margin-bottom: 0;
  }
  li {
    line-height: 1.7;
    margin-left: -2px;
    margin-right: -2px;
    margin-bottom: 15px;
  }

  li:last-of-type {
    margin-bottom: 0;
  }
`;
DropDownContent.displayName = 'DropDownContent';

const IconSvg = styled.svg`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: 6px;
`;
IconSvg.displayName = 'IconSvg';

function createIcon(icon) {
  if (icon === 'calendar' || icon === 'calendarcheck') {
    return (
      <IconSvg
        viewBox="0 0 50 50"
        fill="#42484D"
        height="20px"
        width="20px">
        <path d={iconPaths[icon]} />
      </IconSvg>
    )
  } else {
    return (
      <IconSvg
        viewBox="0 0 11 19"
        height="19px"
        width="11px">
        fill="#42484D">
        <path d={iconPaths[icon]} />
        <ellipse id="Oval" transform="translate(5.634249, 2.147696) rotate(-83.788255) translate(-5.634249, -2.147696) " cx="5.63424896" cy="2.1476965" rx="1.85886474" ry="1.88005015"></ellipse>
      </IconSvg>
    )
  }
}

export default ({
  setDropDown,
  dropDown,
  title,
  text,
  button,
  buttonLink,
  dollar,
  body,
  buttonAnalyticsId,
  dropDownAnalyticsCollapseId,
  dropDownAnalyticsExpandId,
  buttonLabel,
  sizeChecker,
  bannerText = '',
  features = []
}) => {
  const [cardDropDown, setCardDropDown] = useState(false);
  const indyCard = sizeChecker ? dropDown : cardDropDown;
  const isFeatured = `${bannerText}`;

  return (
    <CardWrapper featured={isFeatured}>
      <BannerWrapper featured={isFeatured}>&nbsp;{bannerText}&nbsp;</BannerWrapper>
      <ContentWrapper>
        <h2>{title}</h2>
        <p className='quick-text'>{text}</p>
        <FeatureWrapper>
          {features.map((feature, index) => (
            <Feature key={index}>
              {createIcon(feature.icon)}
              { feature.text}
            </Feature>
          ))}
        </FeatureWrapper>

        <ButtonContainer>
          <a
            href={buttonLink}
            data-analytics-id={buttonAnalyticsId}
            data-analytics-label={buttonLabel}
          >
            <Button>{button}</Button>
          </a>
        </ButtonContainer>
        <hr />
        <DropDownButtonContainer>
          <DropDownButton
            onClick={() => {
              indyCard ? setDropDown(false) : setDropDown(true);
              indyCard ? setCardDropDown(false) : setCardDropDown(true);
            }}
          >
            <span
              className='text-button-style'
              data-analytics-id={
                indyCard ? dropDownAnalyticsCollapseId : dropDownAnalyticsExpandId
              }
            >
              What’s treated
              <FontAwesomeIcon
                icon={indyCard ? faChevronUp : faChevronDown}
                data-analytics-id={
                  indyCard
                    ? dropDownAnalyticsCollapseId
                    : dropDownAnalyticsExpandId
                }
              />
            </span>
          </DropDownButton>
          <p className='dolla-dolla-bills'>{dollar}</p>
        </DropDownButtonContainer>
          <DropDownContent
            style={{ transition: `max-height 1s ease`, maxHeight: indyCard ? "500px" : "0"}}
            >
            <ul>
              {body.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </DropDownContent>
      </ContentWrapper>
    </CardWrapper>
  );
};

